export const supplierOperationsQuotesInventoryArticle = {
  title: 'Supplier Operations Hub: Quotes, Solutions & Inventory',
  slug: 'supplier-operations-quotes-inventory',
  content: `Supplier Operations Hub: Quotes, Solutions & Inventory

Track pricing requests, solutions, and stock in one place.

1) Quotes
- Open the Quotes tab to log pricing requests and negotiations.
- Use it to track status and values.

2) Solutions
- The Solutions tab captures supplier offerings and packages.
- Keep solution notes aligned with quotes.

3) Inventory
- The Inventory tab tracks available stock and records.
- Update inventory as quotes convert to orders.

4) Analytics
- Use Analytics to review supplier activity and pipeline health.
`,
};
